import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { BiAddMediaClickOrigin } from '../../../constants/Bi';
import { ItemType } from '../../../constants/ItemType';
import { ModalName } from '../../../constants/ModalName';
import { ExternalSource } from '../../../constants/Source';
import { SystemFolderId } from '../../../constants/SystemFolderId';
import { createHOCWithHookInside } from '../../hoc/createHOCWithHookInside';
import { useMMGRSettings } from '../../hoc/withMMGRSettings';
import { useModalHandlersAndOptions } from './useModal';
import { useStorageQuotaAwareHandler } from '../storageQuota/useStorageQuotaAwareHandler';
import { StorageQuotaUseCase } from '../storageQuota/useStorageQuotaAwareHandler/StorageQuotaUseCase';

export const useFilesImporter = () => {
  const { openModal } = useModalHandlersAndOptions(ModalName.FilesImporter);
  const storageQuotaAware = useStorageQuotaAwareHandler();
  const {
    mmgrSettings: { siteMediaToken },
  } = useMMGRSettings();
  const { formatMessage } = useIntl();

  const openFilesImporterModal = useCallback(() => {
    const folderPath = [
      {
        id: 'wix-sites',
        kind: ItemType.Folder,
        name: formatMessage({ id: 'files-source.label.wix-site' }),
        siteId: null,
        source: 'wixSite',
      },
      {
        id: JSON.stringify({ siteMediaToken, id: 'media-root' }),
        kind: ItemType.Folder,
        source: 'wixSite',
        name: formatMessage({ id: 'files-source.label.current_site' }),
        parentId: SystemFolderId.WixSites,
      },
      {
        id: JSON.stringify({ siteMediaToken, id: 'wix-video-library-link' }),
        kind: ItemType.Folder,
        name: formatMessage({ id: 'files-source.label.video_library' }),
        parentId: JSON.stringify({ siteMediaToken, id: 'media-root' }),
        source: 'wixSite',
      },
    ];

    openModal({
      defaultSource: ExternalSource.WixSite,
      openedFrom: BiAddMediaClickOrigin.WixVideoLibrary,
      folderPath,
    });
  }, [openModal, formatMessage, siteMediaToken]);

  return { openFilesImporterModal: storageQuotaAware(openFilesImporterModal, StorageQuotaUseCase.UPLOAD) };
};

/**
 * @deprecated use "useModalHandlersAndOptions"
 */
export const withFilesImporter = createHOCWithHookInside('WithFilesImporter', useFilesImporter);
